import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=968ba656&scoped=true&"
import script from "./NotificationsButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsButton.vue?vue&type=style&index=0&id=968ba656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ba656",
  null
  
)

component.options.__file = "NotificationsButton.vue"
export default component.exports